export const DISMISS_REMIND_UI = 'DISMISS_REMIND';
